import styled from "styled-components";

export const HeaderContainer = styled.div`
  padding: 24px 32px 31px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ebeef2;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BreadcrumbContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  color: #6b7280;
  padding-top: 20px;
`;

export const BreadcrumbItem = styled.span`
  color: ${({ active }) => (active ? "#111827" : "#6b7280")};
  font-weight: ${({ active }) => (active ? "500" : "400")};
`;

export const BreadcrumbSeparator = styled.span`
  color: #9ca3af;
`;

export const HeaderTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #333333;
  margin: 0;
`;

export const DescricaoHeader = styled.p`
  font-size: 16px;
  color: #4b5563;
  margin-top: 4px;
`;
